<template>
  <div class="queryTalkDetail" id="nowPrintDetail">
    <div class="detailItem">
      <div class="detailName">约谈对象：</div>
      <div class="detailContent">{{detailObj.object}}</div>
    </div>
    <div class="detailItem">
      <div class="detailName">约谈原由：</div>
      <div class="detailContent">{{detailObj.reason}}</div>
    </div>
    <div class="detailDetail">
      <div class="detailDetailWrap" v-for="(item, index) in questionList" :key="index">
        <div class="detailDate">{{item}}</div>
      </div>
    </div>
    <div class="detailItem">
      <div class="detailName">发布时间：</div>
      <div class="detailContent">{{detailObj.releasetime}}</div>
    </div>
    <abstracts
      title="约谈"
      v-if="detailObj.status == 1"
      :content="detailObj.content"
      :imglist="imgList"
      @load="load"
    />
  </div>
</template>

<script>
import Abstracts from "@/components/Events/Abstracts";

export default {
  name: "QueryTalkDetail",
  components: {
    Abstracts,
  },
  props: {
    detailObj: {
      type: Object,
      default() {
        return {};
      },
    },
    questionList: {
      type: Array,
      default: () => [],
    },
    imgList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    load() {
      this.$emit("load");
    },
  },
};
</script>

<style lang="less" scoped>
.queryTalkDetail {
  padding: 30px 20px;
  .detailItem {
    font-size: 15px;
    margin-top: 24px;
    display: flex;
    color: #707b86;
    .detailContent {
      color: #3b445a;
    }
  }

  .detailDetail {
    box-sizing: border-box;
    padding: 16px;
    background: #f5f5f5;
    margin-top: 16px;
    border-radius: 2px;
  }

  .detailDetailWrap {
    font-size: 14px;
    color: #99a9ba;
    display: flex;
    width: 100%;
    &:not(:first-child) {
      margin-top: 14px;
    }
    .detailDate {
      position: relative;
      padding-left: 12px;
      margin-right: 6px;
      &::before {
        content: "";
        position: absolute;
        top: 7px;
        left: -6px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: RGBA(255, 197, 95, 1);
      }
    }
  }
}
</style>